import { api } from '$app/api';

const data = (res) => res.data;

export const listImportJobs = (segment) => api.get('/garage-imports', { params: { segment } }).then(data);

export const getImportJob = (jobId) => api.get(`/garage-imports/${jobId}`).then(data);

export const listImportRows = (jobId) => api.get(`/garage-imports/${jobId}/rows`).then(data);

export const confirmImportJob = (jobId) => api.post(`/garage-imports/${jobId}/confirm`, {}).then(data);

export const getImportResult = (jobId) => api.get(`/garage-imports/${jobId}/result`).then(data);

export const getImportTemplate = (segment, mode) =>
  api.get('/garage-imports/template', { params: { segment, mode } }).then(data);

export const exportSegmentGarages = (segment) =>
  api.get('/garage-imports/export', { params: { segment } }).then(data);

/**
 * Uploads the CSV straight to S3 with a presigned URL, then asks garage to
 * validate it. The S3 PUT must not carry Maia's Authorization header, so it
 * uses fetch rather than the shared api client.
 */
export async function uploadImportFile({ segment, mode, file }) {
  const { uploadUrl, fileKey } = await api.post('/garage-imports/upload-url', { segment }).then(data);
  const response = await fetch(uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': 'text/csv' },
    body: file,
  });
  if (!response.ok) {
    throw new Error(`Upload failed with status ${response.status}`);
  }
  return api.post('/garage-imports', { segment, mode, fileKey, fileName: file.name }).then(data);
}

/** Saves a { fileName, content } CSV from the API as a download. */
export function downloadCsv({ fileName, content }) {
  const url = URL.createObjectURL(new Blob([content], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
